import React from 'react';
import { Form, Select } from 'antd';
import './CustomerSelectInput.scss';

function CustomerSelectInput({
  name,
  label,
  innerLabel,
  noError,
  className,
  options,
  arrow,
  disabled = false,
  errorMessage,
  search = true,
  rules = [],
  onChange = () => {},
  prefix,
  allowClear = false,
  additionalClassName,
}) {
  return (
    <div className={`${additionalClassName} flex-1`}>
      {prefix && <span className="prefix-icon">{prefix}</span>}
      <Form.Item
        rules={rules}
        validateStatus={errorMessage && 'error'}
        help={!noError && errorMessage}
        className={`customer-select ${className}`}
        name={name}
        label={label}
        style={{ marginBottom: noError && 0 }}
      >
        <Select
          showSearch={search}
          placeholder={innerLabel}
          popupClassName="customer-select-dropdown"
          suffixIcon={arrow}
          options={options}
          disabled={disabled}
          allowClear={allowClear}
          filterOption={
            (inputValue, option) => option
              .label.toLowerCase()
              .includes(inputValue.toLowerCase())
            }
          onChange={(e) => {
            onChange(e);
            return e;
          }}
        />
      </Form.Item>
    </div>
  );
}

export default CustomerSelectInput;
